<div class="card h-200">
  <div class="card-body" style="padding-bottom: 0px" id="headingProject{{ project.id }}">
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="title-project text-xs font-weight-bold text-primary text-uppercase mb-1 col">
            <a [routerLink]="['/projects', project.id, 'planning']" (click)="setOpenProject()">
              <i class='bx bx-file'></i>{{ project?.title }}</a>
          </div>
        </div>
        <div class="row align-items-center col" style="margin-top: 10px">
          <div class="author-project">Autor(es):&nbsp;</div>
          <span *ngFor="let item of project?.authors; let i = index" [ngClass]="{
              'text-primary font-weight-extra-bold': item.author_principal
            }">
            <div class="author-project">
              <b class="font-weight-bold">
                {{ item?.name | nickname
                }}<span *ngIf="i + 1 < project?.authors.length">,&nbsp;</span>
              </b>
            </div>
          </span>
        </div>
        <div class="row align-items-center col" [hidden]="!project?.advisor">
          <div class="author-project">Orientador&nbsp;</div>
          <span class="author-project">
            {{ project?.advisor?.name }}
          </span>
        </div>
        <div class="row align-items-center col" [hidden]="!project?.cosupervisor">
          <div class="author-project">Coorientador&nbsp;</div>
          <span class="author-project">
            {{ project?.cosupervisor?.name }}
          </span>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row no-gutters align-items-center">
          <div class="col-auto">
            <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800" style="position: relative;
            top: 3px;">
              {{ project?.percentage || 0 }}%
            </div>
          </div>
          <div class="col">
            <ngb-progressbar type="info" [value]="project?.percentage"></ngb-progressbar>
          </div>

          <!-- menu edicao -->
          <div class="dropdown" *ngIf="showDropdown">
            <button type="button" class="btn-actions btn btn-link btn-sm dropdown-toggle" style="margin-top: -5px"
              id="dropdownMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class='bx bx-dots-vertical-rounded'></i>
            </button>
            <div class="dropdown-menu dropdown-menu-lg-left">
              <!-- <button class="dropdown-item" type="button" (click)="clone(project)">
                <i class="fa-fw fa fa-clone" aria-hidden="true"></i>
                Clonar
              </button> -->
              <button class="dropdown-item" type="button" (click)="openProject(project)">
                <i class='bx bx-edit'></i>
                Edição rápida
              </button>
              <!--button class="dropdown-item" type="button" (click)="openSettings(project)">
                <i class="fa-fw fa fa-cogs" aria-hidden="true"></i>
                Configurações
              </button>-->
              <button class="dropdown-item" type="button" (click)="openInvitation(project)">
                <i class='bx bx-share'></i>
                Convidar/Desconvidar
              </button>
              <button *ngIf="leaveProject" class="dropdown-item" type="button" (click)="onLeaveProject(project)">
                <i class='bx bx-confused'></i>
                Deixar projeto
              </button>

              <button class="dropdown-item" type="button" (click)="transferProject(project)">
                <i class='bx bx-transfer'></i>
                Mover
              </button>

              <button class="dropdown-item" type="button" (click)="downloadPdf(project)">
                <i class='bx bxs-file-pdf'></i>
                Baixar PDF
              </button>
              <!-- <button class="dropdown-item" type="button" (click)="openStatus(project)">
                <i class="fa-fw fa fa-clipboard" aria-hidden="true"></i>
                Status/Lembretes
              </button> -->
              <!--button class="dropdown-item" type="button" (click)="openHistoric(project)">
                <i class="fa-fw fa fa-history" aria-hidden="true"></i>
                Histórico
              </button-->
              <button *ngIf="deleteProject" class="dropdown-item text-danger" type="button"
                (click)="openDelete(project)">
                <i class='bx bx-trash'></i>
                Excluir
              </button>
            </div>
          </div>

          <div class="dropdown" *ngIf="showDropdownMyStudents">
            <button type="button" class="btn-actions btn btn-link btn-sm dropdown-toggle" style="margin-top: -5px"
              id="dropdownMenuMyStudents" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class='bx bx-dots-vertical-rounded'></i>
            </button>
            <div class="dropdown-menu dropdown-menu-lg-left">
              <button class="dropdown-item" type="button" (click)="onLeaveProject(project)">
                <i class='bx bx-trash'></i>
                Deixar projeto
              </button>
              <button class="dropdown-item" type="button" (click)="downloadPdf(project)">
                <i class='bx bxs-file-pdf'></i>
                Baixar PDF
              </button>
            </div>
          </div>
        </div>

        <div class="row no-gutters col d-flex justify-content-end">
          <div class="info">
            <b>{{ forecastDay(project?.forecast_date) }}</b> até a entrega
          </div>
        </div>
        <div class="row no-gutters col d-flex justify-content-end">
          <b class="info"><i class='bx bx-calendar'></i> {{
            project?.forecast_date | date: "dd/MM/yyyy"
            }}</b>
        </div>
        <div class="row col d-flex justify-content-end" style="margin: 0; padding-top: 8px">
          <p class="badge badge-status" *ngIf="checkStatus(project?.status)">
            {{
            statusProject + checkPresentingStatus(project?.presenting_status)
            }}
          </p>
        </div>
        <div class="row d-flex col justify-content-end" style="margin: 0px">
          <button class="btn btn-link collapsed" href="javascript:void(0)" style="margin: 0px; padding: 0px"
            data-toggle="collapse" [attr.data-target]="'#project' + project?.id" aria-expanded="false"
            aria-controls="collapseThree">
            <p class="info">detalhes <i class='bx bx-menu-alt-right'></i></p>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div id="project{{ project?.id }}" class="collapse"
    data-parent="#accordion">
    <div class="card-body" style="padding-top: 0px">
      <div class="row">
        <div class="details col-md-12" style="margin-bottom: 5px">
          <b>Questão Problema:</b>
          {{ researchQuestionsText }}
        </div>
      </div>
      <div class="row">
        <div class="details col-md-12" style="margin-bottom: 5px">
          <b>Justificativa:</b>
          {{ justification }}
        </div>
      </div>
      <div class="row">
        <div class="details col-md-12">
          <b>Objetivo Geral:</b>
          {{ mainGoal }}
        </div>
      </div>
    </div>
  </div>
</div>
